import moment from 'moment-timezone'

export interface IClonedInfo {
  updated_by: string;
  source_id: string;
}

export class IBuilderMeta {
  migrated?: boolean;
  oldId?: string;
}
export class Versions {
  updatedBy?: string;
  downloadUrl: string;
  downloadPath: string;
  versionId:string;
  createdAt?: moment.Moment;
  updatedAt?: moment.Moment;
}

export class Builder {
  locationId: string
  type: string
  downloadUrl: string
  deleted: boolean
  archived: boolean
  originId: string

  lastUsed: moment.Moment
  builderVersion: string
  name: string
  downloadPath: string
  versionHistory: Versions[]
  fromName: string
  fromAddress?: string
  subjectLine?: string
  previewText?: string
  updatedBy?: string

  clonedInfo?: IClonedInfo

  createdAt: moment.Moment
  updatedAt: moment.Moment
  emailData?: string
  meta?: IBuilderMeta
  _id: string
}

export interface VersionHistory {
  updated_by: string;// user id
  updated_at: typeof moment;
  download_url: string;
  download_path: string;
  version_id: string;

}

export enum TemplateType {
  HTML = 'html',
  BUILDER = 'builder'
}

export default class EmailBuilder extends Builder {

  public constructor(init?: Partial<EmailBuilder>) {
    super();
    Object.assign(this, init);
  }
  set id(id: string) {
    // do nothing
  }

  private static getEmailServiceHeaders(channel="APP") {
    return {
      channel: channel,
      source: 'WEB_USER',
      version: '2021-07-28',
    }
  }

  get id(): string {
    return this._id;
  }
}
